import "../styles/AboutSerene-2.css";
import centerImage from "../assets/serene-images/aboutusgifimage.avif";
import { motion } from "framer-motion";

const containerLeft = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07,
    },
  },
};

const containerRight = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07,
    },
  },
};

const leftItem = {
  hidden: {
    opacity: 0,
    x: -60,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.4,
      ease: "easeOut",
    },
  },
};

const rightItem = {
  hidden: {
    opacity: 0,
    x: 60,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.4,
      ease: "easeOut",
    },
  },
};

const mobileContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.04,
    },
  },
};

const mobileItem = {
  hidden: {
    opacity: 0,
    y: 24,
    filter: "blur(6px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
};

export default function AboutSereneTwo() {
  const leftPoints = [
    "Peace and charm without being far from vibrant life.",
    "A refreshing break from the city's clamour, providing a soothing escape from daily distractions.",
    "From the curve of a beam to the finish of a tile, each element is thoughtfully chosen to bring quiet sophistication and timeless charm.",
    "Each space is shaped with care - to feel cozy, look beautiful, and stay close to nature.",
  ];

  const rightPoints = [
    "Beyond generous square footage, they offer room for relaxation, connection, and reflection.",
    "With open-plan living, spacious lounges, and sunlit courtyards, each villa becomes a sanctuary where privacy and time are yours to command.",
    "While nature and privacy set the tone, the amenities seal the indulgence.",
    "Villas are the ultimate backdrop for life's most treasured celebrations.",
  ];

  const mobilePoints = [...leftPoints, ...rightPoints];

  return (
    <section className="serene-narrative container-fluid position-relative" id="about-serene">
      <div className="serene-bottom-overlay"></div>
      <div className="container p-0 position-relative z-1">
        <motion.div
          className="serene-mobile-layout"
          variants={mobileContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.6 }}
        >
          <div className="serene-mobile-image-wrap">
            <img src={centerImage} alt="Serene Living" className="img-fluid serene-mobile-image" />
          </div>
          <div className="serene-mobile-points">
            {mobilePoints.map((point, index) => (
              <motion.div className="serene-mobile-point" key={index} variants={mobileItem}>
                <p>{point}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <div className="row align-items-center justify-content-between">
          <motion.div
            className="col-lg-4 serene-col serene-left p-0"
            variants={containerLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.6 }}
          >
            {leftPoints.map((text, index) => (
              <motion.div
                key={`left-${index}`}
                className={`serene-item ${index % 2 === 1 ? "bordered" : ""}`}
                variants={leftItem}
                style={
                  index === 0
                    ? { borderTop: "1px solid #5f7a558f", paddingTop: "15px", paddingRight: "30px" }
                    : index === 2
                      ? { paddingRight: "30px" }
                      : undefined
                }
              >
                <p>{text}</p>
                {index === leftPoints.length - 1 && <span className="line long"></span>}
              </motion.div>
            ))}
          </motion.div>

          <div className="col-lg-4 d-none serene-center text-center p-0">
            <img src={centerImage} alt="Serene Living" className="img-fluid serene-image" />
          </div>

          <motion.div
            className="col-lg-4 serene-col serene-right p-0"
            variants={containerRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.6 }}
          >
            {rightPoints.map((text, index) => (
              <motion.div
                key={`right-${index}`}
                className={`serene-item ${index % 2 === 1 ? "bordered" : ""}`}
                variants={rightItem}
                style={
                  index === 0
                    ? { borderTop: "1px solid #5f7a558f", paddingTop: "15px", paddingLeft: "30px" }
                    : index === 2
                      ? { paddingLeft: "30px" }
                      : undefined
                }
              >
                <p>{text}</p>
                {index === rightPoints.length - 1 && <span className="line long"></span>}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
